import { createGlobalStyle } from 'styled-components';
import { Theme } from 'utils/color/horizonTheme';

import { Form } from 'antd5';
import styled from 'styled-components';

// Globally-applied overrides for Forms and Inputs
export const FormAndInputStyles = createGlobalStyle`
  ${({ theme }) =>
    `
    .ant-input,
    .ant-input-number,
    .ant-input-number-input-wrap > input,
    .ant-input-number-handler-wrap,
    .ant-input-number-handler > span,
    .ant-select-selector,
    .ant-picker,
    .ant-picker-input > input,
    .ant-input-affix-wrapper,
    .ant-input-affix-wrapper-disabled {
      background: ${theme.inputBackgroundColor} !important;
      border-color: ${theme.buttonBorderColor} !important;
      color: ${theme.headerColor} !important;
    }

    /* Override browser autofill styles to maintain theme colors */
    .ant-input:-webkit-autofill,
    .ant-input:-webkit-autofill:hover,
    .ant-input:-webkit-autofill:focus,
    .ant-input:-webkit-autofill:active,
    .ant-input-affix-wrapper > input:-webkit-autofill,
    .ant-input-affix-wrapper > input:-webkit-autofill:hover,
    .ant-input-affix-wrapper > input:-webkit-autofill:focus,
    .ant-input-affix-wrapper > input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 1000px ${theme.inputBackgroundColor} inset !important;
      -webkit-text-fill-color: ${theme.headerColor} !important;
      caret-color: ${theme.headerColor} !important;
      transition: background-color 5000s ease-in-out 0s;
    }

    .ant-input-group-addon > button {
      background: ${theme.buttonBackgroundColor};
      border: 1px solid ${theme.buttonBorderColor} !important;
      border-radius: unset !important;
      color: ${theme.headerColor} !important;

      &:hover {
        background: ${theme.secondaryBackgroundColor};
      }
    }

    .ant-input-number-group-addon {
      background: ${theme.buttonBackgroundColor};
      border: 1px solid ${theme.buttonBorderColor} !important;
      border-radius: unset !important;
      border-right-width: 0 !important;
      color: ${theme.headerColor} !important;
    }
    
    .ant-checkbox-wrapper {
      color: ${theme.headerColor} !important;
    }
    .ant-checkbox:not(.ant-checkbox-checked) {
      .ant-checkbox-inner {
        background-color: ${theme.checkboxBackgroundColor} !important;
        border-color: ${theme.buttonBorderColor} !important;
      }
    }
    .ant-checkbox-disabled + span {
      color: ${theme.disabledTextColor};
    }

    .ant-checkbox {
      top: 0;
    }

    .ant-radio-wrapper {
      color: ${theme.headerColor} !important;
    }
    .ant-radio:not(.ant-radio-checked) {
      .ant-radio-inner {
        background-color: ${theme.checkboxBackgroundColor} !important;
        border-color: ${theme.buttonBorderColor} !important;
      }
    }
    .ant-radio-disabled + span {
      color: ${theme.disabledTextColor};
    }

    .ant-form-item,
    .ant-form-item-label > label {
      color: ${theme.headerColor} !important;
    }

    .ant-form-item-has-error {
      margin-bottom: 24px;
    }

    .ant-table-filter-dropdown {
      color: ${theme.headerColor} !important;
    }

    ${
      theme.themeName === Theme.Dark &&
      `
      .ant-input-disabled,
      .ant-input-number-disabled,
      .ant-input-number-disabled > .ant-input-number-input-wrap > input,
      .ant-select-disabled > .ant-select-selector,
      .ant-picker-disabled,
      .ant-picker-disabled > .ant-picker-input > input {
          background: ${theme.disabledBackground} !important;
        
      }

      .ant-select-arrow,
      .ant-picker-suffix,
      .ant-picker-clear,
      .ant-select-clear {
        color: ${theme.labelColor} !important;
      }
      .ant-picker-clear,
      .ant-select-clear {
        background: ${theme.inputBackgroundColor} !important;
      }

      .ant-picker-panel-container {
        background: ${theme.tertiaryBackgroundColor} !important;

        .ant-picker-cell {
          color: ${theme.disabledTextColor} !important;

          &.ant-picker-cell-in-view {
            color: ${theme.textColor} !important;
          }
        }

        .ant-picker-cell-disabled{
        
        &::before {
          background: ${theme.disabledBackground};
        }
      
        .ant-picker-cell-inner {
          color: ${theme.disabledTextColor};
        }
      }

        .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner,
        .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
        .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before,
        .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
          background: ${theme.selectedListItemBackground};
        }

        .ant-picker-header,
        .ant-picker-content th {
          color: ${theme.headerColor} !important;
        }

        .ant-picker-header-next-btn,
        .ant-picker-header-super-next-btn,
        .ant-picker-header-prev-btn,
        .ant-picker-header-super-prev-btn {
          color: ${theme.secondaryTextColor} !important;
        }

        .ant-picker-ranges .ant-picker-preset > .ant-tag-blue {
          background: ${theme.activeMenuItemBackgroundColor};
        } 
      }

      input::placeholder,
      .ant-select-selection-placeholder {
        color: ${theme.disabledTextColor} !important;
      }

      .ant-select {
        .ant-select-selection-overflow-item {
          .ant-select-selection-item {
            background: ${theme.activeMenuItemBackgroundColor};
            border-color: ${theme.tertiaryBackgroundColor};
            color: ${theme.secondaryTextColor};
          }
          .ant-select-selection-item-remove {
            color: ${theme.secondaryTextColor};
          }
        }
      }

      .ant-select-dropdown {
        background: ${theme.tertiaryBackgroundColor};
        color: ${theme.headerColor};

        .ant-select-item {
          color: ${theme.headerColor};

          &:hover,
          &:active,
          &:focus,
          &.ant-select-item-option-active:not(.ant-select-item-option-disabled),
          &.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
            background-color: ${theme.activeMenuItemBackgroundColor} !important;
            color: ${theme.secondaryTextColor};
          }

          &.ant-select-item-disabled  {
            color: ${theme.disabledTextColor};

            &:hover,
            &:active {
              background-color: unset;
            }
          }
        }
      }
      .ant-radio-group {
        .ant-radio-button-wrapper {
          background: ${theme.buttonBackgroundColor};
          border-color: ${theme.buttonBorderColor};
          color: ${theme.headerColor};
        
          &.ant-radio-button-wrapper-checked,
          .ant-radio-button-checked {
            border-color: ${theme.teal};
            border-left-width: 1px;
            color: ${theme.teal};
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          display: none;
        }

        &.ant-radio-group-solid {
          .ant-radio-button-wrapper-checked {
            color: ${theme.headerColor};

            .ant-radio-button-checked {
              background: ${theme.teal};
              border-color: ${theme.teal};
            }
          }    
        }
      }
      
      p {
        color: ${theme.textColor};
      }
    
      .ant-switch:not(.ant-switch-checked) {
        background-color: ${theme.checkboxBackgroundColor};
      }
      `
    }
  `}
`;

// Individual component styles for V5 specifically
export const StyledFormItem = styled(Form.Item)`
  .ant-form-item-margin-offset {
    margin: 0 !important;
  }
`;
